module.exports = __webpack_public_path__ + "img/icon-plant-4.95e7c61a.svg";